import imgHuifen from "@assets/events-awards/dta/img-chen-huifen.png";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Ms Chen Huifen Section on DTA Judges Page
 */
const HuifenSection = (): React.ReactElement => {
  return (
    <AccordionV2
      testId="huifen-section-component"
      className="border border-t-0 border-gray-175 bg-gray-150 py-4"
      headerChildren={
        <EventsAwardsAccordionHeader
          title="Ms Chen Huifen"
          className="tracking-normal"
        />
      }
      arrowClassName="border-none h-auto w-auto -rotate-90 mr-6"
      isArrowRight
    >
      <div className="mt-4 flex flex-col border-t border-gray-175 px-6 pt-4 md:flex-row">
        <div className="mb-6 h-auto w-8/12 pr-4 md:mb-2 md:w-2/12 md:pr-5">
          <img
            src={imgHuifen}
            width={576}
            height={283}
            alt="ms-chen-huifen"
            className="object-contain"
          />
        </div>

        <div className="md:w-8/12 md:pl-1 md:pr-1">
          <p className="mb-0 font-bold">Ms Chen Huifen</p>

          <p className="font-bold">Editor, The Business Times</p>

          <p>
            Chen Huifen started her career with SPH Media in the digital realm,
            initially as a content producer for BT Online, before branching out
            to become a journalist.
          </p>

          <p>
            She left in 2002 to teach English and International Understanding in
            rural Japan, only to realise that she missed the newsroom buzz.
            Post-Sars, she returned to The Business Times to develop a new beat
            in biomedical sciences for the publication. Other than tracing
            Singapore&apos;s R&D drive, she has also covered technology,
            macroeconomics, government policy, and healthcare. She has also
            overseen the Young Investor Forum as well as the SME sections of the
            paper. She is the founding editor of BT&apos;s bimonthly The SME
            Magazine in 2010.
          </p>

          <p>
            Huifen switched to a full-time supervisory role in 2014 and in the
            past one and a half years, helped Wei Kong and other key members of
            the leadership team to steer the newsroom into adopting a
            digital-first mindset.
          </p>
        </div>
      </div>
    </AccordionV2>
  );
};
export default HuifenSection;
